import { SHELL } from './test-ids';
import { APP_NAME_KEYS, type AmpAppId, type AmpAppShellConfig } from './app-shell.model';

export function shellConfig(appId: AmpAppId): AmpAppShellConfig {
  return {
    appId,
    appNameKey: APP_NAME_KEYS[appId],
    logoUrl: '/logo.svg',
    nav: [
      {
        labelKey: 'shell.nav.home',
        link: '/',
        testId: SHELL.NAV_HOME,
        fontIcon: 'home',
      },
    ],
  };
}
